import gql from 'graphql-tag';

export const TOGGLE_DISCOUNT_CODES_FOR_RENTERS = gql`
  mutation ToggleDiscountCodesForRenters($input: ToggleDiscountCodesForRentersInput!) {
    toggleDiscountCodesForRenters(input: $input) {
      success
      error
      venue {
        id
        discountCodesForRenters
      }
    }
  }
`;
